import React from 'react';
import LoadingSequence from 'assets/Loading/LoadingSequence';
import WidgetDiagnostics from './WidgetDiagnostics';
import { useWidgetFetch } from 'hooks/useWidgetFetch';
import { apiPath } from 'apiurl';

const CADENCE_URL = `${apiPath}/api/dashboard-status/cadence-counts?timeRange=all`;

const STATE_META = {
  C: { label: 'Completed', badgeClass: 'bg-success' },
  R: { label: 'Ready',     badgeClass: 'bg-primary' },
  F: { label: 'Failed',    badgeClass: 'bg-danger'  },
};

function CadenceCard() {
  const { data, loading, timing } = useWidgetFetch(CADENCE_URL, {
    ttl: 10 * 60 * 1000,
    swr: 20 * 60 * 1000,
    widgetId: 'Cadence',
  });

  const states = Array.isArray(data) ? data : [];

  return (
    <div className="kpi-card kpi-card--status kpi-card--diagnostics-outside" style={{ position: 'relative' }}>
      <WidgetDiagnostics timing={timing} url={CADENCE_URL} panelPlacement="above" />
      {loading ? <LoadingSequence message="" size="small" /> : (
        <>
          <p className="kpi-label">Cadence State</p>
          <div className="run-status-breakdown">
            {states.length === 0 ? (
              <div className="run-status-row">
                <span className="run-label" style={{ color: '#94a3b8' }}>No data</span>
              </div>
            ) : (
              states.map(({ state, count }) => {
                const meta = STATE_META[state] || { label: state, badgeClass: 'bg-secondary' };
                return (
                  <div className="run-status-row" key={state}>
                    <span className="run-label">{meta.label}</span>
                    <span className={`badge ${meta.badgeClass}`} style={{ fontSize: '13px' }}>
                      {Number(count).toLocaleString()}
                    </span>
                  </div>
                );
              })
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default CadenceCard;
